module.exports = __webpack_public_path__ + "static/img/theater_cate.15093ed.15093ed9.jpg";